(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mkplayer", [], factory);
	else if(typeof exports === 'object')
		exports["mkplayer"] = factory();
	else
		root["mkplayer"] = factory();
})(self, () => {
return 